'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _graphDisplay = require('../graph-display');

var _graphDisplay2 = _interopRequireDefault(_graphDisplay);

var _inputField = require('./../input-field');

var _inputField2 = _interopRequireDefault(_inputField);

var _inputSelect = require('./../input-select');

var _inputSelect2 = _interopRequireDefault(_inputSelect);

var _largeButton = require('../large-button');

var _largeButton2 = _interopRequireDefault(_largeButton);

var _graphConfigs = require('./graph-configs');

var _graphConfigs2 = _interopRequireDefault(_graphConfigs);

var _equalizer = require('../../equalizer');

var _equalizer2 = _interopRequireDefault(_equalizer);

var _inputWithSelect = require('./../input-with-select');

var _inputWithSelect2 = _interopRequireDefault(_inputWithSelect);

var _fractional = require('./../../../server/models/inch-pound/lib/fractional');

var _fractional2 = _interopRequireDefault(_fractional);

var _inchParser = require('./../../../server/models/inch-pound/lib/inch-parser');

var _inchParser2 = _interopRequireDefault(_inchParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultKT = '2 7/8';

var t1Control = [{
    min: '49 7/32',
    max: '72 27/32',
    value: '25 19/32'
}, {
    min: '72 7/8',
    max: '112 27/32',
    value: '35 7/16'
}];

var ConnectorInchForm = function (_React$Component) {
    _inherits(ConnectorInchForm, _React$Component);

    function ConnectorInchForm(props) {
        _classCallCheck(this, ConnectorInchForm);

        var _this = _possibleConstructorReturn(this, (ConnectorInchForm.__proto__ || Object.getPrototypeOf(ConnectorInchForm)).call(this, props));

        _this.showErrorMessage = _this.showErrorMessage.bind(_this);

        _this.graphConfig = _graphConfigs2.default[props.formKey];
        _this.parser = (0, _inchParser2.default)().parseInchString;

        _this.getRangeM = _this.getRangeM.bind(_this);
        return _this;
    }

    _createClass(ConnectorInchForm, [{
        key: 'showErrorMessage',
        value: function showErrorMessage() {
            var error = this.props.invalidFields.filter(function (field) {
                return !field.fieldName;
            })[0];

            if (!error) return;

            return _react2.default.createElement(
                'div',
                { className: 'cell small-8 xlarge-7 general-error' },
                _react2.default.createElement(
                    'p',
                    null,
                    error.label
                )
            );
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            (0, _equalizer2.default)();

            window.onpopstate = function (e) {
                return _this2.props.reset(e);
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _props$data = this.props.data,
                tb = _props$data.tb,
                kt1 = _props$data.kt1,
                eh = _props$data.eh,
                z1 = _props$data.z1,
                z2 = _props$data.z2;

            var rangeM = this.getRangeM(tb, kt1, eh, z1, z2);

            return _react2.default.createElement(
                'div',
                { className: 'grid-x grid-padding-x' },
                this.showErrorMessage(),
                _react2.default.createElement(
                    'div',
                    { className: 'cell small-12 large-9' },
                    _react2.default.createElement(
                        'form',
                        { onSubmit: this.props.save },
                        _react2.default.createElement(
                            'div',
                            { className: 'grid-x grid-padding-x small-up-1 medium-up-2 large-up-3' },
                            _react2.default.createElement(
                                'div',
                                { className: 'cell' },
                                _react2.default.createElement(_inputSelect2.default, {
                                    pleaseChoose: this.props.labels.pleaseChoose,
                                    label: this.props.labels.material,
                                    id: this.props.formKey + '-m',
                                    name: 'material',
                                    options: this.props.materials,
                                    onChange: this.props.materialChange,
                                    value: this.props.data.material,
                                    error: this.props.invalidFields.filter(function (field) {
                                        return field.fieldName === 'material';
                                    })[0]
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'cell' },
                                _react2.default.createElement(_inputField2.default, {
                                    label: this.props.labels.weight,
                                    id: this.props.formKey + '-weight',
                                    name: 'weight',
                                    value: this.props.data.weight,
                                    disabled: this.props.weightDisabled,
                                    change: this.props.valueChange,
                                    showBadge: false,
                                    error: this.props.invalidFields.filter(function (field) {
                                        return field.fieldName === 'weight';
                                    })[0]
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'grid-x grid-padding-x small-up-1 medium-up-2 large-up-3',
                                'data-equalizer-container': true },
                            _react2.default.createElement(
                                'div',
                                { className: 'cell' },
                                _react2.default.createElement(_inputWithSelect2.default, {
                                    pleaseChoose: '',
                                    label: this.props.labels.eh,
                                    id: this.props.formKey + '-eh',
                                    name: 'eh',
                                    value: this.props.data.eh,
                                    change: this.props.valueChange,
                                    range: this.props.config.eh.range,
                                    error: this.props.invalidFields.filter(function (field) {
                                        return field.fieldName === 'eh';
                                    })[0]
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'cell' },
                                _react2.default.createElement(_inputWithSelect2.default, {
                                    pleaseChoose: '',
                                    label: this.props.labels.tb,
                                    id: this.props.formKey + '-tb',
                                    name: 'tb',
                                    value: this.props.data.tb,
                                    change: this.props.valueChange,
                                    range: this.props.config.tb.range,
                                    error: this.props.invalidFields.filter(function (field) {
                                        return field.fieldName === 'tb';
                                    })[0]
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'grid-x grid-padding-x small-up-1 medium-up-2 large-up-3 space-3',
                                'data-equalizer-container': true },
                            _react2.default.createElement(
                                'div',
                                { className: 'cell' },
                                _react2.default.createElement(_inputWithSelect2.default, {
                                    pleaseChoose: '',
                                    label: this.props.labels.s,
                                    id: this.props.formKey + '-s',
                                    name: 's',
                                    value: this.props.data.s,
                                    change: this.props.valueChange,
                                    range: this.props.config.s.range,
                                    error: this.props.invalidFields.filter(function (field) {
                                        return field.fieldName === 's';
                                    })[0]
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'cell' },
                                _react2.default.createElement(_inputWithSelect2.default, {
                                    pleaseChoose: '',
                                    label: this.props.labels.z1,
                                    id: this.props.formKey + '-z1',
                                    name: 'z1',
                                    value: this.props.data.z1,
                                    change: this.props.valueChange,
                                    range: this.props.config.z1.range,
                                    error: this.props.invalidFields.filter(function (field) {
                                        return field.fieldName === 'z1';
                                    })[0],
                                    filterSelectToMinMax: true
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'cell' },
                                _react2.default.createElement(_inputWithSelect2.default, {
                                    pleaseChoose: '',
                                    label: this.props.labels.z2,
                                    id: this.props.formKey + '-z2',
                                    name: 'z2',
                                    value: this.props.data.z2,
                                    change: this.props.valueChange,
                                    range: this.props.config.z2.range,
                                    error: this.props.invalidFields.filter(function (field) {
                                        return field.fieldName === 'z2';
                                    })[0],
                                    filterSelectToMinMax: true
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'cell' },
                                _react2.default.createElement(_inputWithSelect2.default, {
                                    pleaseChoose: '',
                                    label: this.props.labels.z3,
                                    id: this.props.formKey + '-z3',
                                    name: 'z3',
                                    value: this.props.data.z3,
                                    change: this.props.valueChange,
                                    range: this.props.config.z3.range,
                                    error: this.props.invalidFields.filter(function (field) {
                                        return field.fieldName === 'z3';
                                    })[0],
                                    filterSelectToMinMax: true
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'cell' },
                                _react2.default.createElement(_inputWithSelect2.default, {
                                    pleaseChoose: '',
                                    label: this.props.labels.kt1,
                                    id: this.props.formKey + '-kt1',
                                    name: 'kt1',
                                    value: this.props.data.kt1,
                                    change: this.props.valueChange,
                                    range: this.props.config.kt1.range,
                                    error: this.props.invalidFields.filter(function (field) {
                                        return field.fieldName === 'kt1';
                                    })[0]
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'cell' },
                                _react2.default.createElement(_inputWithSelect2.default, {
                                    pleaseChoose: '',
                                    label: this.props.labels.m,
                                    id: this.props.formKey + '-m',
                                    name: 'm',
                                    value: this.props.data.m,
                                    change: this.props.valueChange,
                                    disabled: !rangeM,
                                    range: rangeM,
                                    error: this.props.invalidFields.filter(function (field) {
                                        return field.fieldName === 'm';
                                    })[0]
                                })
                            )
                        ),
                        _react2.default.createElement(_largeButton2.default, {
                            text: this.props.labels.calculate,
                            disabled: this.props.buttonDisabled
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'cell large-3 show-for-large' },
                    _react2.default.createElement(_graphDisplay2.default, {
                        config: this.graphConfig })
                )
            );
        }

        /**
         *
         * @param tb
         * @param kt1
         * @param eh
         * @param z1
         * @param z2
         * @returns {*}
         */

    }, {
        key: 'getRangeM',
        value: function getRangeM(tb, kt1, eh, z1, z2) {
            var _this3 = this;

            var rangeM = null;

            if (tb && kt1 && eh && z1 && z2) {
                var localTB = this.parser(tb + '"');
                var localKT1 = this.parser(kt1 + '"');
                var localKT = this.parser(defaultKT + '"');
                var localEH = this.parser(eh + '"');
                var localZ1 = this.parser(z1 + '"');
                var localZ2 = this.parser(z2 + '"');

                var th = localEH - localZ1 - localZ2;
                var t1 = localTB + localKT - localKT1;

                rangeM = {
                    min: (0, _fractional2.default)(t1),
                    max: tb
                };

                t1Control.forEach(function (toTest) {
                    var localMin = _this3.parser(toTest.min + '"');
                    var localMax = _this3.parser(toTest.max + '"');
                    var localValue = _this3.parser(toTest.value + '"');

                    if (th >= localMin && th <= localMax && localKT1 > localValue) {
                        rangeM.min = (0, _fractional2.default)(localTB - localValue + localKT);
                    }
                });
            }

            //Limit range m to 0-14"
            if (rangeM) {
                if (this.parser(rangeM.min + '"') < 0) rangeM.min = 0;
                if (this.parser(rangeM.max + '"') < 0) rangeM.max = 0;
            }

            return rangeM;
        }
    }]);

    return ConnectorInchForm;
}(_react2.default.Component);

ConnectorInchForm.propTypes = {
    formKey: _propTypes2.default.string.isRequired,
    save: _propTypes2.default.func.isRequired,
    valueChange: _propTypes2.default.func.isRequired,
    materials: _propTypes2.default.array.isRequired,
    materialChange: _propTypes2.default.func.isRequired,
    data: _propTypes2.default.object.isRequired,
    weightDisabled: _propTypes2.default.bool.isRequired,
    config: _propTypes2.default.object.isRequired,
    labels: _propTypes2.default.object.isRequired,
    buttonDisabled: _propTypes2.default.bool.isRequired,
    invalidFields: _propTypes2.default.array,
    reset: _propTypes2.default.func
};

exports.default = ConnectorInchForm;


//////////////////
// WEBPACK FOOTER
// ./client/components/connector-inch-form/index.js
// module id = 489
// module chunks = 0